export function DrawerHeader() {
  return (
    <div className="px-6">
      <span className="text-lg font-bold tracking-tight text-sidebar-foreground">TipMi Admin</span>
    </div>
  );
}
